import { gql } from 'graphql-request';

import {
  RoleID,
  RoleUUID,
  RoleName,
  RoleDescription,
  RoleCreatedAt,
  RoleUpdatedAt
} from '../rolesTypes';

export interface FetchRolesQueryResponse {
  id: RoleID;
  uuid: RoleUUID;
  name: RoleName;
  description: RoleDescription;
  createdAt: RoleCreatedAt;
  updatedAt: RoleUpdatedAt;
}

export const FETCH_ROLES_QUERY = gql`
  query Roles(
    $filters: RolesFilters
    $sort: [RolesSortEnum!]
    $limit: Int
    $offset: Int
  ) {
    roles(filters: $filters, sort: $sort, limit: $limit, offset: $offset) {
      nodes {
        id
        uuid
        name
        description
        createdAt
        updatedAt
      }
      paginationInfo {
        nextPage
        totalCount
      }
      sql
    }
  }
`;
